import React from 'react';
import FastMarquee from 'react-fast-marquee';

const MarqueeStrip = ({ texts = ["FRESH", "HOT", "TASTY", "38 CM", "CROCCANTE"], bgColor = "bg-santomato-red" }) => {
  return (
    <div className={`${bgColor} border-y-4 border-black py-3 overflow-hidden`} data-testid="marquee-strip">
      <FastMarquee speed={30} gradient={false}>
        {texts.map((text, index) => (
          <span key={index} className="font-fredoka font-semibold text-2xl md:text-3xl text-white uppercase tracking-wider mx-10 flex items-center">
            {text}
            <span className="mx-10 text-santomato-yellow">★</span>
          </span>
        ))}
      </FastMarquee>
    </div>
  );
};

export default MarqueeStrip;
